/**
 * 一覧の頭（#241、docs/94 B-3・★5、Figma ③ 249:66・② 249:127）。一覧の型の画面（見積書・請求書・{project}・{vendorQuote}・見積依頼・{order}・仕入・{paymentNotice}・送付状）が使う。
 *   ・題の行は 題だけ（戻るのある画面は 戻る＋題。仕入｜{paymentNotice} の切り替えのような題の一部は extra）。前は題の行の右にあった作成のボタンは タブの段の右端へ
 *   ・タブの段は表のカードの中の上辺（.lcard。タブの下線と表の見出しの上の線が同じ線＝間を空けない）：タブ（左）｜絞り込み（残りの幅の中央）｜主ボタン（右端）＝ListTabs の filter・create
 *   ・1段に入らないときは 絞り込みを題の行の右へ（タブと主ボタンは同じ段のまま）。入るかは ListTabs が測って、この部品の題の行の場所（ListHeadSlot）へ移す
 *   ・タブは均等のまま、いちばん長いタブの幅に詰める（文字 15px・件数の丸 13px・左右の余白 12px・高さ 52px＝styles.css の .lcard）。700px 以下の形は今のまま（ListTabs）
 *   ・一覧の検索は「絞り込み」：漏斗の絵＋「番号・{vendor}・件名で絞り込み」（上の帯の検索と形を分ける）＝FilterInput
 * 新しい一覧の画面もこの部品で作る（docs/10 §9.30 画面の型）
 */
import { createContext, useContext, useState, type ReactNode } from "react";

/** 題の行の中の、絞り込みを移す場所（ListTabs が 1段に入らないときに createPortal で入れる） */
const ListHeadSlot = createContext<HTMLElement | null>(null);
export const useListHeadSlot = () => useContext(ListHeadSlot);

/** 一覧の絞り込みの欄（漏斗の絵＋ placeholder。type="search" にしない＝上の帯の検索と形を分ける） */
export function FilterInput({ value, onChange, placeholder, testId, id }: { value: string; onChange: (v: string) => void; placeholder: string; testId?: string; id?: string }) {
  return (
    <span className="lfilter">
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M3 5h18l-7 8v6l-4-2v-4z" />
      </svg>
      <input id={id} className="inp" value={value} onChange={(e) => onChange(e.target.value)} placeholder={placeholder} aria-label={placeholder} data-testid={testId} />
    </span>
  );
}

export function ListHead({ title, titleTestId, back, extra, children }: { title: ReactNode; titleTestId?: string; /** 戻るボタン（BackButton）。題の左に並ぶ */ back?: ReactNode; /** 題のすぐ右（仕入｜{paymentNotice} の切り替えなど） */ extra?: ReactNode; children: ReactNode }) {
  const [slot, setSlot] = useState<HTMLSpanElement | null>(null);
  return (
    <>
      {back}
      <div className="hrow lhead">
        <h1 data-testid={titleTestId}>{title}</h1>
        {extra}
        <span className="lhead-filter" ref={setSlot} />
      </div>
      <ListHeadSlot.Provider value={slot}>{children}</ListHeadSlot.Provider>
    </>
  );
}
